<div class="advanced-analytics">
  <div class="row mb-4 align-items-end">
    <div class="col-md-6">
      <h4>{{ 'KPI.ANALYTICS.TITLE' | translate }}</h4>
      <p class="text-muted mb-0">{{ 'KPI.ANALYTICS.SUBTITLE' | translate }}</p>
    </div>
    <div class="col-md-6">
      <app-report-filter-bar
        [showStoreFilter]="false"
        [showExportDetailLevel]="true"
        [disabled]="loading"
        (filterChange)="onFilterChange($event)"
        (exportRequested)="onExport($event)">
      </app-report-filter-bar>
    </div>
  </div>

  <!-- Totals with comparison -->
  <div class="row mb-4" *ngIf="report?.totals">
    <div class="col-md-6">
      <nb-card class="summary-card">
        <nb-card-body class="text-center">
          <div class="summary-label">{{ 'KPI.ANALYTICS.TOTAL_REVENUE' | translate }}</div>
          <div class="summary-value">{{ formatCurrency(report.totals.totalRevenue) }}</div>
          <small *ngIf="comparison.available && comparison.totals?.revenue"
            [class]="deltaClass(comparison.totals.revenue.deltaPct)">
            {{ formatDelta(comparison.totals.revenue.deltaPct) }} {{ 'KPI.ANALYTICS.VS_PREVIOUS_PERIOD' | translate }}
          </small>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-md-6">
      <nb-card class="summary-card">
        <nb-card-body class="text-center">
          <div class="summary-label">{{ 'KPI.ANALYTICS.TOTAL_QUANTITY' | translate }}</div>
          <div class="summary-value">{{ formatNumber(report.totals.totalQuantity) }}</div>
          <small *ngIf="comparison.available && comparison.totals?.quantity"
            [class]="deltaClass(comparison.totals.quantity.deltaPct)">
            {{ formatDelta(comparison.totals.quantity.deltaPct) }} {{ 'KPI.ANALYTICS.VS_PREVIOUS_PERIOD' | translate }}
          </small>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- BA Breakdown -->
  <nb-card *ngIf="baBreakdown.length > 0">
    <nb-card-header>{{ 'KPI.ANALYTICS.BA_BREAKDOWN' | translate }}</nb-card-header>
    <nb-card-body class="p-0">
      <div class="ba-list">
        <div class="ba-row" *ngFor="let ba of baBreakdown">
          <div class="ba-header" (click)="toggleBa(ba.baId)">
            <div class="ba-name">
              <nb-icon [icon]="isExpanded(ba.baId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
              <strong>{{ ba.baName }}</strong>
              <nb-badge *ngIf="ba.pctOfTotal != null" status="info" class="ms-2" [text]="ba.pctOfTotal.toFixed(1) + '%'"></nb-badge>
            </div>
            <div class="ba-metrics">
              <span>{{ formatCurrency(ba.totalRevenue) }}</span>
              <span class="text-muted ms-3">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}: {{ formatNumber(ba.totalQuantity) }}</span>
            </div>
          </div>
          <div class="varegruppe-table" *ngIf="isExpanded(ba.baId)">
            <div class="table-responsive product-table-scroll mb-2">
              <table class="table table-sm mb-0 product-table">
                <thead>
                  <tr>
                    <th>{{ 'KPI.ANALYTICS.EAN' | translate }}</th>
                    <th>{{ 'KPI.ANALYTICS.SKU' | translate }}</th>
                    <th>{{ 'KPI.ANALYTICS.PRODUCT' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TAX_RATE' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_EX_TAX' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="subtotal-row">
                    <td>-</td>
                    <td>-</td>
                    <td><strong>{{ ba.baName }} ({{ 'KPI.ANALYTICS.SUBTOTAL' | translate }})</strong></td>
                    <td class="text-end">{{ formatNumber(ba.totalQuantity) }}</td>
                    <td class="text-end">{{ formatTaxRate(ba.taxRatePercent) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitCostPriceInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitSellingPriceInclTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitProfitInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalInclTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalProfitInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitCostPriceExTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitSellingPriceExTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitProfitExTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalExTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalProfitExTax, true) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>{{ 'KPI.ANALYTICS.VAREGRUPPE' | translate }}</th>
                  <th class="text-end">{{ 'KPI.DASHBOARD.REVENUE' | translate }}</th>
                  <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                  <th class="text-end">{{ 'KPI.ANALYTICS.PRODUCTS' | translate }}</th>
                  <th class="text-end">{{ 'KPI.ANALYTICS.PCT_OF_TOTAL' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let vg of ba.varegrupper || []">
                  <tr class="vg-row" (click)="toggleVg(ba.baId, vg.categoryId)">
                    <td>
                      <nb-icon [icon]="isVgExpanded(ba.baId, vg.categoryId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
                      {{ vg.categoryName }}
                    </td>
                    <td class="text-end">{{ formatCurrency(vg.totalRevenue) }}</td>
                    <td class="text-end">{{ formatNumber(vg.totalQuantity) }}</td>
                    <td class="text-end">{{ formatNumber(vg.uniqueProductCount) }}</td>
                    <td class="text-end">
                      <nb-badge *ngIf="vg.pctOfTotal != null" status="basic" [text]="vg.pctOfTotal.toFixed(1) + '%'"></nb-badge>
                      <span *ngIf="vg.pctOfTotal == null">-</span>
                    </td>
                  </tr>
                  <tr *ngIf="isVgExpanded(ba.baId, vg.categoryId)">
                    <td colspan="5" class="product-detail-cell">
                      <div class="table-responsive product-table-scroll" *ngIf="vg.products?.length">
                        <table class="table table-sm mb-0 product-table">
                          <thead>
                            <tr>
                              <th>{{ 'KPI.ANALYTICS.EAN' | translate }}</th>
                              <th>{{ 'KPI.ANALYTICS.SKU' | translate }}</th>
                              <th>{{ 'KPI.ANALYTICS.PRODUCT' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TAX_RATE' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_EX_TAX' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="subtotal-row">
                              <td>-</td>
                              <td>-</td>
                              <td><strong>{{ vg.categoryName }} ({{ 'KPI.ANALYTICS.SUBTOTAL' | translate }})</strong></td>
                              <td class="text-end">{{ formatNumber(vg.totalQuantity) }}</td>
                              <td class="text-end">{{ formatTaxRate(vg.taxRatePercent) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitCostPriceInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitSellingPriceInclTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitProfitInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalInclTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalProfitInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitCostPriceExTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitSellingPriceExTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitProfitExTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalExTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalProfitExTax, true) }}</td>
                            </tr>
                            <ng-container *ngFor="let product of vg.products">
                              <tr class="product-row" (click)="toggleProduct(ba.baId, vg.categoryId, product.productId)">
                                <td>
                                  <nb-icon [icon]="isProductExpanded(ba.baId, vg.categoryId, product.productId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
                                  {{ product.ean || '-' }}
                                </td>
                                <td>{{ product.sku || '-' }}</td>
                                <td>{{ product.name }}</td>
                                <td class="text-end">{{ formatNumber(product.totalQuantity) }}</td>
                                <td class="text-end">{{ formatTaxRate(product.taxRatePercent) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitCostPriceInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitSellingPriceInclTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitProfitInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalInclTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalProfitInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitCostPriceExTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitSellingPriceExTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitProfitExTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalExTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalProfitExTax, true) }}</td>
                              </tr>
                              <tr *ngIf="isProductExpanded(ba.baId, vg.categoryId, product.productId)" class="product-sales-row">
                                <td colspan="15" class="product-sales-cell">
                                  <div class="product-sales-panel">
                                    <div class="product-sales-heading text-muted small mb-2">{{ 'KPI.ANALYTICS.INDIVIDUAL_SALES' | translate }}</div>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="text-center py-2">
                                      <nb-spinner size="tiny"></nb-spinner>
                                    </div>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.error"
                                      class="text-danger py-2">
                                      {{ 'KPI.ANALYTICS.LOAD_SALES_ERROR' | translate }}
                                    </div>
                                    <div *ngIf="!productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading
                                      && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.error
                                      && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="text-muted py-2">
                                      {{ 'KPI.ANALYTICS.NO_SALES_IN_PERIOD' | translate }}
                                    </div>
                                    <table *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="table table-sm mb-0 product-sales-table">
                                      <thead>
                                        <tr>
                                          <th>{{ 'KPI.ANALYTICS.DATE' | translate }}</th>
                                          <th>{{ 'KPI.ANALYTICS.TIME' | translate }}</th>
                                          <th>{{ 'KPI.ANALYTICS.BASKET_ID' | translate }}</th>
                                          <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let sale of productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].rows">
                                          <td>{{ formatOrderDate(sale.orderDate) }}</td>
                                          <td>{{ formatOrderTime(sale.orderDate) }}</td>
                                          <td>{{ sale.orderNumber }}</td>
                                          <td class="text-end">{{ formatNumber(sale.quantity) }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.pagination
                                      && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].currentPage < productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].pagination.totalPages"
                                      class="text-center py-2">
                                      <button type="button" class="btn btn-sm btn-outline-primary"
                                        [disabled]="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading"
                                        (click)="loadMoreProductSales(ba.baId, vg.categoryId, product.productId); $event.stopPropagation()">
                                        <span *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length">
                                          <nb-spinner size="tiny"></nb-spinner>
                                        </span>
                                        <span *ngIf="!(productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length)">
                                          {{ 'KPI.ANALYTICS.LOAD_MORE' | translate }}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="!ba.varegrupper?.length">
                  <td colspan="5" class="text-center text-muted py-3">{{ 'KPI.ANALYTICS.NO_VAREGRUPPER' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="!loading && baBreakdown.length === 0">
    <nb-card-body class="text-center py-5">
      <nb-icon icon="bar-chart-outline" class="large-icon text-muted mb-3"></nb-icon>
      <h5>{{ 'KPI.ANALYTICS.NO_DATA' | translate }}</h5>
      <p class="text-muted mb-0">{{ 'KPI.ANALYTICS.NO_DATA_HINT' | translate }}</p>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">{{ 'KPI.DASHBOARD.LOADING' | translate }}</p>
</ngx-spinner>
